import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import PartNumberCodeQueryList from './query/list';
import EditOrClonePartNumberCode from './edit';
import AddPartNumberCode from './add';

export const partNumberCodeRoutes = [
  {
    'component': <PartNumberCodeQueryList />,
    'path': paths.PartNumberCodeQueryList,
  },
  {'component': <EditOrClonePartNumberCode />, 'path': paths.EditPartNumberCode},
  {'component': <EditOrClonePartNumberCode />, 'path': paths.ClonePartNumberCode},
  {'component': <AddPartNumberCode />, 'path': paths.AddPartNumberCode},
];
